<script>
    import { Route, Link, useLocation} from 'svelte-navigator';
    import { jwt } from './store.js';
    import Movie from './Movie.svelte';
    import Links from './Links.svelte';
    import Find from './Find.svelte';
    import Login from './Login.svelte';
    
    const currentLocation = useLocation();
    $: console.log($currentLocation);

</script>
<main>
    <nav>
        {#if $jwt !== null && $jwt !== undefined && $jwt != '' &&  $currentLocation.pathname !== '/'}
            <Link to="/"><a>Movie</a></Link>
        {/if}
        {#if $jwt !== null && $jwt !== undefined && $jwt != '' && $currentLocation.pathname !== '/find'}
            <Link to="/find"><a>Find</a></Link>
        {/if}
    </nav>
    <Route path="/" component={Movie} />
    <Route path="/links" component={Links} />
    <Route path="/find" component={Find} />
    <Route path="/login" component={Login} />

    <img class="icon" on:click|preventDefault={() => navigate('/')} src="favicon.jpeg" alt="Pingouin site icon">
</main>

<style>
    nav {
        margin-top: 1rem;
    }
    nav a {
        color: #fff;
        text-decoration: none;
        margin: 50px 15px;
        padding: 10px 20px;
        border-radius: 5px;
        transition: background-color 0.3s ease;
        background-color: #4957ae;
    }

    nav a:hover {
        background-color: #354190;
        text-decoration: none;
    }

    .icon {
        position: absolute;
        top: 5px;
        right: 5px;
        width: 100px;
        height: 100px;
        border-radius: 50%;

        cursor: pointer;

        @media (max-width: 768px) {
            width: 50px;
            height: 50px;
        }
    }
</style>
